
<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <transition name="slide" mode="out-in">
          <v-alert
            style="z-index: 1"
            v-if="err"
            prominent
            border="top"
            type="error"
          >
            <v-row align="center">
              <v-col class="grow">
                ไม่มีเลขอ้างอิง '{{ errText }}' ในระบบ
              </v-col>
              <v-col class="shrink">
                <v-btn outlined @click="err = false"
                  ><v-icon color="white" x-large
                    >mdi-close-circle</v-icon
                  ></v-btn
                >
              </v-col>
            </v-row>
          </v-alert>
        </transition>
        <v-row class="mb-5">
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="d-flex justify-end align-center;">
            <v-btn
              class="btn-color"
              v-on="on"
              outlined
              color="indigo"
            >
            <download-excel
                class="d-flex btn btn-default text-white"
                :data="export_data"
                :fields="export_fields"
                :type="exportType"
                :worksheet="exportWorksheet"
                :name="exportFileName"
              >
                <v-icon color="indigo">
                  mdi-download
                </v-icon>
                <p class="mb-0 indigo--text">Export Data</p>
              </download-excel>
            </v-btn>
          </v-col>
        </v-row>
        <!-- data table -->
        <!-- <v-row class="pa-5 mb-6">
          <v-btn
            dark
            style="background-color: rgb(27, 67, 124)"
            @click="dialog = true"
          >
            <v-icon left>mdi-card-account-details-outline</v-icon>
            ดึงเหรียญกลับแบบมีเลขอ้างอิง
          </v-btn>
        </v-row> -->
        <v-dialog v-model="dialog" persistent max-width="600px" >
          <v-card>
            <v-card-title class="pl-5">
              <div
                style="
                  color: black;
                  border-radius: 7px;
                "
              >
                <v-icon color="black" left
                  >mdi-card-account-details-outline</v-icon
                >
                ดึงเหรียญกลับแบบมีเลขอ้างอิง
              </div>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      style="padding: 0 !important"
                      v-model="refId"
                      label="เลขอ้างอิง"
                      outlined
                      hide-details
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="note"
                      style="padding: 0 !important"
                      label="หมายเหตุ*"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green"
                :disabled="!refId || !note"
                @click="getRefIdandProfileUser()"
              >
                <v-icon color="white" >mdi-magnify</v-icon>
                ตกลง
              </v-btn>
              <v-btn color="red" dark @click="closeDialogRefId()">
                <v-icon class="mr-2" color="white"
                  >mdi-close-circle</v-icon
                >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog3" persistent max-width="600px">
          <v-card class="pa-5">
            <v-card-title>
              <div
                class=""
                style="
                  color: black;
                "
              >
                กรุณาใส่หมายเหตุ
              </div>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col class="pl-0" cols="12" style="display:flex;justify-content: center;font-weight: bolder;align-items: baseline;">
                    <h4 class="mr-3 mb-0" style="font-weight: bold;">ดึง {{point}} คะแนน</h4>
                    <div><v-icon class="pb-0 mr-3">mdi-arrow-left-circle</v-icon></div>
                    <div class="mr-3"><v-list-item-avatar
                          style="border: 2px solid #dfbb9d;margin-right: 0px;margin-top: 0px;"
                        >
                          <v-img :src="dataUser.picture"></v-img>
                        </v-list-item-avatar></div>
                    <h4 class="mb-0" style="font-weight: bold;">{{dataUser.name}}</h4>
                  </v-col>
                  <v-col v-if="refID" class="pa-0" style="display:flex;"><div>*** หมายเลขอ้างอิง :</div> <div style="font-weight: bolder;" class="ml-2">{{refID}}</div></v-col>
                  <v-col cols="12" class="pl-0">
                    <v-text-field
                      v-model="note2"
                      style="padding: 0 !important"
                      label="หมายเหตุ*"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#1b437c"
                class="text--white"
                :disabled="!note2"
                @click="refundCoin()"
              >
                <v-icon color="white" class="pb-1">mdi-cash-refund</v-icon>
                <b style="color:white">ดึงคะแนน</b>
              </v-btn>
              <v-btn color="red" dark @click="closeDialog3RefId()">
                <v-icon class="mr-2" color="white"
                  >mdi-close-circle</v-icon
                >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end data table -->
        <v-dialog max-width="900px" style="height: 300px" v-model="dialog2">
          <template>
            <v-card class="pa-0">
              <v-toolbar
                style="font-weight: bold"
                color="#173053"
                dark
                class="pl-5"
              >
                <v-icon color="white" style="margin-right: 10px"
                  >mdi-card-account-details-outline</v-icon
                >ดึงเหรียญใช้เลขอ้างอิง</v-toolbar
              >
              <div style="display: flex">
                <v-row no-gutters>
                  <v-col
                    cols="5"
                    align="center"
                    style="align-self: center; font-weight: bold"
                    class="pb-3 pt-3 pl-8 pr-8"
                  >
                    <v-card class="pa-4" style="border: 4px solid #e0deca">
                      <div>ต้องการดึงเหรียญจำนวน</div>
                      <div>{{ point }}</div>
                      <div>เหรียญ</div>
                    </v-card>
                  </v-col>
                  <v-col
                    class="pt-0"
                    cols="2"
                    align="center"
                    style="align-self: center"
                  >
                    <!-- <v-icon color="red">mdi-cash-refund</v-icon> -->
                    <v-btn
                      dark
                      style="background-color: rgb(27, 67, 124)"
                      @click="refundCoin()"
                    >
                      <v-icon left>mdi-cash-refund</v-icon>
                      ดึงเหรียญ
                    </v-btn>
                  </v-col>
                  <v-col cols="5" align="center" class="pb-3 pt-3 pl-8 pr-8">
                    <v-card class="pa-4" style="border: 4px solid #e0deca">
                      <div style="display: flex; justify-content: center">
                        <v-list-item-avatar
                          class="mr-7"
                          style="border: 2px solid #dfbb9d"
                        >
                          <v-img :src="dataUser.picture"></v-img>
                        </v-list-item-avatar>
                        <div style="align-self: center; font-weight: bold">
                          <p class="mb-0">{{ dataUser.name }}</p>
                        </div>
                      </div>
                      <div style="align-self: center">
                        <div style="display: flex">
                          <div style="font-weight: bold">
                            <v-icon color="#7F8487" style="margin-right: 10px"
                              >mdi-card-account-details-star</v-icon
                            >ระดับสมาชิก :
                          </div>
                          <div style="display: flex">
                            <v-list-item-avatar class="ml-3 mr-2" size="25">
                              <v-img :src="dataUser.pictureUrl"></v-img>
                            </v-list-item-avatar>
                            <div style="font-weight: bold">
                              {{ dataUser.LevelName }}
                            </div>
                          </div>
                        </div>
                        <div style="display: flex">
                          <div style="font-weight: bold">
                            <v-icon color="#7F8487" style="margin-right: 6px"
                              >mdi-alpha-c-circle-outline</v-icon
                            >เหรียญปัจจุบัน :
                          </div>
                          <div style="display: flex" class="ml-3">
                            <div style="font-weight: bold">
                              {{ dataUser.currentPoint }}
                            </div>
                          </div>
                        </div>
                        <div style="display: flex">
                          <div style="font-weight: bold">
                            <v-icon color="#7F8487" style="margin-right: 6px"
                              >mdi-cellphone</v-icon
                            >เบอร์โทรศัพท์ :
                          </div>
                          <div style="display: flex" class="ml-3">
                            <div style="font-weight: bold">
                              {{ dataUser.tel }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </template>
        </v-dialog>
        <v-card>
          <v-tabs v-model="tab" color="#1b437c">
            <v-tab>
              <h4>ดึงคะแนนกลับแบบไม่มีเลขอ้างอิง</h4>
            </v-tab>
            <v-tab>
              <h4>ประวัติดึงคะแนนกลับ</h4>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-row class="mt-2 pl-2">
                <v-col cols="3">
                  <v-text-field
                    v-if="session.data.shopId !== shopNameData.SHOP_ID_CHUBB"
                    outlined
                    v-model="tel"
                    :rules="[rules.counterTel, rules.required]"
                    v-mask="'###-###-####'"
                    hint="ค้นหาสมาชิกโดยเบอร์โทรศัพท์"
                    label="เบอร์โทรศัพท์"
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-if="session.data.shopId === shopNameData.SHOP_ID_CHUBB"
                    outlined
                    v-model="tel"
                    :rules="[rules.empId, rules.required]"
                    hint="ค้นหาสมาชิกโดยรหัสพนักงาน"
                    label="รหัสพนักงาน"
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-select
                    outlined
                    dense
                    v-model="select"
                    color="blue"
                    :items="dataExchange"
                    item-text="name"
                    item-value="productExchangeRateId"
                    label="สินค้า/บริการ"
                  >
                    <template v-slot:prepend>
                      <v-icon color="red"></v-icon> </template
                  ></v-select>
                </v-col>
                <v-col cols="3" class="pr-1">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    nudge-top="21px"
                    nudge-right="16px"
                    min-width="290px"
                    style="top: 283px !important"
                  >
                    <template v-slot:activator="slotProps">
                      <v-text-field
                        class="pr-1"
                        v-model="date1"
                        label="วันที่"
                        dense
                        hint="ค้นหาโดยวันที่"
                        v-bind="slotProps.attrs"
                        outlined
                        readonly
                        v-on="slotProps.on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      ref="picker1"
                      v-model="date1"
                      :max="new Date().toISOString().substr(0, 10)"
                      min="1950-01-01"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  align="center"
                  justify="space-around"
                  cols="3"
                  class="pl-6"
                >
                  <v-btn
                    :disabled="!tel"
                    @click="searchData()"
                    color="green"
                    class="white--text bold--text"
                    ><v-icon color="white">mdi-magnify</v-icon>ค้นหา</v-btn
                  >
                  <v-btn @click="clearData()" color="red" class="white--text bold--text"
                    ><v-icon color="white">mdi-close-circle</v-icon
                    >ยกเลิก</v-btn
                  >
                </v-col>
              </v-row>
              <v-data-table
                :headers="columns"
                :items="qrCodeData"
                :items-per-page="10"
                :loading="load"
                loading-text="Loading... Please wait"
              >
                <template v-slot:[`item.picture`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.picture" alt="img"
                  /></v-avatar>
                </template>
                <template v-slot:[`item.refId`]="{ item }">
                  {{ displayRefId(item) }}
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        color="#1b437c"
                        dark
                        @click.stop="openDialogRefund(item)"
                      >
                        <v-icon dark class="pb-1 mr-1"> mdi-cash-refund </v-icon>
                        <b>ดึงคะแนน</b>
                      </v-btn>
                    </template>
                    <span>ดึงคะแนน</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <v-data-table
                :headers="columns2"
                :items="dataHistoryRefundPoint"
                :items-per-page="10"
                loading-text="Loading... Please wait"
              >
                <template v-slot:[`item.picture`]="{ item }">
                  <v-avatar color="primary" size="40">
                    <img :src="item.picture" alt="img"
                  /></v-avatar>
                </template>
                <template v-slot:[`item.point`]="{ item }">
                      {{ formatNumber(item.point) }}
                </template>
                <template v-slot:[`item.LAST_DATE`]="{ item }">
                      {{ format_date(item.LAST_DATE) }}
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
          <!-- <p
            style="
              color: black;
              padding: 12px;
              font-weight: bold;
            "
          >
            ดึงคะแนนกลับแบบไม่มีเลขอ้างอิง
          </p> -->
          <!-- <v-row>
            <v-col cols="3">
              <v-text-field
                outlined
                v-model="tel"
                :rules="[rules.counterTel, rules.required]"
                v-mask="'###-###-####'"
                hint="ค้นหาสมาชิกโดยเบอร์โทรศัพท์"
                label="เบอร์โทรศัพท์"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                outlined
                dense
                v-model="select"
                color="blue"
                :items="dataExchange"
                item-text="name"
                item-value="productExchangeRateId"
                label="สินค้า/บริการ"
              >
                <template v-slot:prepend>
                  <v-icon color="red"></v-icon> </template
              ></v-select>
            </v-col>
            <v-col cols="3" class="pr-1">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                nudge-top="21px"
                nudge-right="16px"
                min-width="290px"
                style="top: 283px !important"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="pr-1"
                    v-model="date1"
                    label="วันที่"
                    dense
                    hint="ค้นหาโดยวันที่"
                    v-bind="attrs"
                    outlined
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker1"
                  v-model="date1"
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              align="center"
              justify="space-around"
              cols="3"
              class="pl-6"
            >
              <v-btn
                :disabled="!tel"
                @click="searchData()"
                color="green"
                class="white--text bold--text"
                ><v-icon color="white">mdi-magnify</v-icon>ค้นหา</v-btn
              >
              <v-btn @click="clearData()" color="red" class="white--text bold--text"
                ><v-icon color="white">mdi-close-circle</v-icon
                >ยกเลิก</v-btn
              >
            </v-col>
          </v-row>
          <v-data-table
            :headers="columns"
            :items="qrCodeData"
            :items-per-page="10"
            :loading="load"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.picture`]="{ item }">
              <v-avatar color="primary" size="40">
                <img :src="item.picture" alt="img"
              /></v-avatar>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="#1b437c"
                    dark
                    @click.stop="openDialogRefund(item)"
                  >
                    <v-icon dark class="pb-1 mr-1"> mdi-cash-refund </v-icon>
                    <b>ดึงคะแนน</b>
                  </v-btn>
                </template>
                <span>ดึงคะแนน</span>
              </v-tooltip>
            </template>
          </v-data-table> -->
        </v-card>
      </div>
    </v-main>
  </div>
</template>
<script>
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue,
    downloadExcel: JsonExcel,
    XLSX
  },
  created () {},
  data () {
    return {
      date: '2018-03-02',
      // path2: '/ReportQRCode/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ดึงเหรียญกลับ',
          disabled: false,
          href: '/Tool/Refund'
        }
      ],
      note: null,
      refId: null,
      tab: null,
      session: this.$session.getAll(),
      dialog: false,
      dialog2: false,
      dialog3: false,
      err: false,
      select: null,
      errText: null,
      // Data Table Config
      dataUser: [],
      dataItem2: [],
      dataExchange: null,
      point: null,
      export_data: null,
      exportType: 'xls',
      exportFileName: 'CN_Billing',
      exportWorksheet: 'WorkSheet',
      body: {
        shopId: '',
        refId: '',
        note: ''
      },
      note2: null,
      qrCodeData: [],
      export_fields: {
        ชื่อ: 'nameCustomer',
        เบอร์โทรศัพท์: 'tel',
        เลขอ้างอิง: 'refId',
        คะแนน: 'point',
        ราคา: 'amount',
        วันที่ดึงคะแนน: 'LAST_DATE'
      },
      columns: [
        { text: 'รูปโปรไฟล์', value: 'picture' },
        { text: 'ชื่อ', value: 'name' },
        { text: 'บริการ/สินค้า', value: 'productExchangeRateName' },
        { text: 'เลขอ้างอิง', value: 'refId' },
        { text: 'โทเคนคิวอาร์โค้ด', value: 'token' },
        { text: 'คะแนนคิวอาร์โค้ด', value: 'point' },
        {text: 'วันที่ได้คะแนน', value: 'LAST_DATE'},
        { text: 'ดึงคะแนน', value: 'action' }
      ],
      columns2: [
        { text: 'รูปโปรไฟล์', value: 'picture' },
        { text: 'ชื่อ', value: 'nameCustomer' },
        { text: 'บริการ/สินค้า', value: 'productExchangeRateName' },
        { text: 'เลขอ้างอิง', value: 'refId' },
        { text: 'โทเคนคิวอาร์โค้ด', value: 'token' },
        { text: 'คะแนน', value: 'point' },
        {text: 'วันที่ดึงคะแนน', value: 'LAST_DATE'},
        {text: 'รหัสที่ดึงคะแนน', value: 'LAST_USER'}
      ],
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length <= 12 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        empId: (value) => {
          const pattern = /^[a-zA-Z]{2}[0-9]{5}$/
          return pattern.test(value) || 'อักษร [A-Z]: 2, ตัวเลข [0-9]: 5 ตัวอย่าง (AA12345).'
        }
      },
      tel: null,
      productEx: null,
      date1: null,
      menu1: false,
      load: false,
      bodyNorefId: null,
      bodytoApi: null,
      refID: null,
      dataHistoryRefundPoint: null
      // End Data Table Config
    }
  },
  async mounted () {
    await this.getProductEx()
    await this.getRefundPointHistory()
    if (this.$session.getAll().data.shopId === 'U4e23f7bf31b362622ff7c5c06dfdf350') {
      this.dataHistoryRefundPoint.map((item) => {
        if (item.bvpBillingNumber) {
          item.refId = item.bvpBillingNumber
        }
      })
      this.export_data = this.dataHistoryRefundPoint
    } else {
      this.export_data = this.dataHistoryRefundPoint
    }
    console.log('this.dataHistoryRefundPoint', this.dataHistoryRefundPoint)
    console.log('this.export_data', this.export_data)
  },
  methods: {
    openDialogRefund (item) {
      this.point = item.point
      this.bodyNorefId = item
      this.refID = this.displayRefId(item)
      this.dialog3 = true
    },
    displayRefId (item) {
      return item.refId || item.bvpBillingNumber || ''
    },
    clearData () {
      this.tel = null
      this.date1 = null
      this.select = null
    },
    async getRefundPointHistory () {
      this.dataHistoryRefundPoint = []
      await axios
        .get(
          this.DNS_IP +
            '/qrcode_refund/get?shopId=' +
            this.session.data.shopId +
            '&status=refund'
        )
        .then(async (response) => {
          if (Array.isArray(response.data)) {
            console.log('dddddd', response.data)
            this.dataHistoryRefundPoint = response.data
          }
          // if (response.data.length > 0) {
          //   console.log(response)
          // } else {
          //   console.log('หาไม่เจอ')
          // }
        })
        .catch((err) => {
          console.log('2', err)
        })
    },
    async searchData () {
      this.load = true
      this.qrCodeData = []
      setTimeout(async () => {
        await axios
          .get(
            this.DNS_IP +
            '/member/get?shopId=' +
            this.session.data.shopId +
            '&tel=' +
            this.tel.split('-').join('').trim()
          )
          .then(async (response) => {
            if (response.data.length > 0) {
              this.dataUser = response.data[0]
              await axios
                .get(
                  this.DNS_IP +
                '/qrcode/get?shopId=' +
                this.session.data.shopId +
                '&tel=' +
                this.tel.split('-').join('').trim() +
                '&last_date_like=' +
                this.date1 +
                '&productExchangeRateId=' +
                this.select +
                '&use'
                )
                .then((response) => {
                  if (response.data.length > 0) {
                    this.qrCodeData = response.data
                    this.load = false
                  } else {
                    this.$swal('ไม่มีข้อมูลในระบบ', `ไม่มีข้อมูลในระบบคะแนนในระบบ`, 'error')
                    console.log('หาเจอ', this.load)
                    this.load = false
                  }
                })
                .catch((err) => {
                  console.log('1', err)
                })
            } else {
              this.$swal(
                'ไม่มีข้อมูลในระบบ',
                `ไม่มีเบอร์โทรนี้เป็นสมาชิกในระบบ ${this.tel}`,
                'error'
              )
              this.load = false
              console.log('หาไม่เจอ', this.load)
            }
          })
          .catch((err) => {
            console.log('2', err)
          })
      }, 1500)
    },
    async getProductEx () {
      this.dataExchange = await this.getDataGlobal(
        this.DNS_IP,
        '/productExchangeRate/',
        this.session.data.shopId
      )
      console.log('dataExchange', this.dataExchange)
    },
    async getRefIdandProfileUser () {
      this.errText = this.refId
      console.log('refId', this.refId)
      console.log('note', this.note)
      await axios
        .get(
          this.DNS_IP +
            '/qrcode_by_refId?' +
            'shopId=' +
            this.$session.getAll().data.shopId +
            '&refId=' +
            this.refId
        )
        .then(async (response) => {
          console.log('response', response.data[0])
          this.point = response.data[0].point
          await axios
            .get(
              this.DNS_IP +
                '/member/get?shopId=' +
                this.$session.getAll().data.shopId +
                '&liffUserId=' +
                response.data[0].LAST_USER
            )
            .then((res) => {
              console.log('res.data[0]', res.data[0])
              this.body.shopId = this.$session.getAll().data.shopId
              this.body.refId = this.refId
              this.body.note = this.note
              this.dataUser = res.data[0]
              this.dialog2 = true
              this.dialog = false
              this.closeDialogRefId()
            })
        })
        .catch((err) => {
          console.log(err)
          this.dialog = false
          this.err = true
          this.refId = null
          this.note = null
        })
    },
    closeDialogRefId () {
      this.dialog = false
      this.refId = null
      this.note = null
    },
    closeDialog3RefId () {
      this.dialog3 = false
      this.note2 = null
      this.bodyNorefId = null
    },
    async refundCoin () {
      console.log('ffff')
      if (this.bodyNorefId) {
        this.bodytoApi = this.bodyNorefId
        this.bodytoApi['note'] = this.note2
      } else {
        this.bodytoApi = this.body
      }
      console.log('this.bodytoApi', this.bodytoApi)
      this.bodytoApi.employee = this.$session.getAll().data.userName
      await axios
        .post(this.DNS_IP + '/refund_coin', this.bodytoApi)
        .then(async (response) => {
          console.log(response.data)
          if (response.data.status === false) {
            this.dialog2 = false
            this.dialog3 = false
            this.$swal(
              'เลขอ้างอิงนี้ได้ดึงเหรียญกลับไปแล้ว',
              `ระบบได้ดึงเหรียญคืนจาก ${this.dataUser.name} จำนวน ${this.point} เหรียญไปแล้ว`,
              'error'
            )
          } else {
            this.dialog2 = false
            this.dialog3 = false
            if (this.bodytoApi.id) {
              this.qrCodeData = this.qrCodeData.filter(el => el.id !== this.bodytoApi.id)
            } else if (this.bodytoApi.refId) {
              this.qrCodeData = this.qrCodeData.filter(el => el.refId !== this.bodytoApi.refId)
            }
            console.log('this.qrCodeData', this.qrCodeData)
            this.$swal(
              'ดึงเหรียญเรียบร้อบ!',
              `ระบบได้ดึงเหรียญคืนจาก ${this.dataUser.name} จำนวน ${this.point} เหรียญ`,
              'success'
            )
          }
          await this.getRefundPointHistory()
        })
        .catch((err) => {
          console.log(err)
          this.dialog = false
          this.err = true
          setTimeout(() => {
            this.err = false
            this.refId = null
            this.note = null
          }, 4000)
        })
      // await axios
      //   .get(
      //     this.DNS_IP +
      //     '/qrcode_by_refId?' +
      //     'shopId=' +
      //     this.$session.getAll().data.shopId + '&refId=' + this.refId
      //   ).then(async (response) => { console.log(response) })
    }
  }
}
</script>
<style scoped>
i.mdi.mdi-menu-down::before {
  color: blue;
}
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 18px;
}
.point {
  font-size: 30px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#margin {
  margin-top: 30px;
  margin-bottom: 50px;
}
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/RefundPoint.vue